import React, { Component } from "react";
import ApiConnect from "../../../../Utils/ApiConnect";
import AnimatedNumber from "animated-number-react";
import cash from "../../../../assets/img/payment/cash.png";
import fonepay from "../../../../assets/img/payment/Fonepay.png";
import bank from "../../../../assets/img/payment/bank.png";
import cashier from "../../../../assets/img/payment/cashier.png";
import { connect } from "react-redux";
import { setTransactions } from "../../../../redux/actions/Modules.Action";

class Transactions extends Component {
  componentDidMount = async () => {
    this.fetchTrans();
  };
  fetchTrans = async () => {
    try {
      ApiConnect.get("/Dashboard/Summary/CashBankDetails")
        .then((response) => {
          this.props.setTransactions(response.data);
        })
        .catch((err) => console.error(err));
    } catch (err) {
      console.log("error facing location:", err);
    }
  };

  render() {
    const formatValue = (value) => `${Number(value).toFixed()}`;
    const cashBank = this.props.tranData;
    return (
      <React.Fragment>
        <div className="col-sm-6 col-xl-3">
          <div className="card shadow-1">
            <div className="card-body">
              <div className="flexbox">
                <img src={cashier} className="avatar-xl" alt="User Cash" />
                <span className="fs-30 fw-100">
                  <AnimatedNumber
                    value={cashBank ? cashBank.user_cash : 0}
                    formatValue={formatValue}
                  />
                </span>
              </div>
              <div className="text-center">Users Cash</div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-xl-3">
          <div className="card shadow-1">
            <div className="card-body">
              <div className="flexbox">
                <img src={cash} className="avatar-xl" alt="Cash" />
                <span className="fs-30 fw-100">
                  <AnimatedNumber
                    value={cashBank ? cashBank.cash.balance : 0}
                    formatValue={formatValue}
                  />
                </span>
              </div>
              <div className="text-center">Cash</div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-xl-3">
          <div className="card shadow-1">
            <div className="card-body">
              <div className="flexbox">
                <img src={bank} className="avatar-xl" alt="Bank" />
                <span className="fs-30 fw-100">
                  <AnimatedNumber
                    value={cashBank ? cashBank.bank.balance : 0}
                    formatValue={formatValue}
                  />
                </span>
              </div>
              <div className="text-center">Bank</div>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-xl-3">
          <div className="card shadow-1">
            <div className="card-body">
              <div className="flexbox py-2">
                <img src={fonepay} height="40" width="95" alt="Fonepay" />
                <span className="fs-30 fw-100">
                  <AnimatedNumber
                    value={cashBank ? cashBank.fonepay.balance : 0}
                    formatValue={formatValue}
                  />
                </span>
              </div>
              <div className="text-center">Fonepay</div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default connect(
  (state) => ({
    tranData: state.Dashboard.transactions,
  }),
  { setTransactions }
)(Transactions);
